export default {
      id: "icon--news-usage",
      viewBox: "0 0 32 30",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--news-usage",
      toString: function () {
        return this.url;
      }
    }